module.exports = __webpack_public_path__ + "img/advice-4.10d1a1c6.png";